export const AssessmentReportType = [
  {
    Paperwork: 1,
    Dictation: 2,
    Draft: 3,
    Completed: 4,
    AmendedReportCompleted: 5,
    ConsentForm: 6,
    EassessClaimantLocationChecklist: 7,
    EassessDoctorLocationChecklist: 8,
    PaperworkOther: 9,
    InvoiceAttachment: 10,
    PaymentRequestedAttachment: 11,
    PrepaymentPaidAttachment: 12,
    DictationInstruction: 13,
    DoctorSample: 14,
    DoctorReportTemplate: 15,
    PaperworkExLink: 16, //Mising field
    PaperworkOtherExLink: 17, //Mising field
    ReportReturnedFromDoctor: 18,
    TypistReport: 19,
    WiroFundingApproval: 20,
  },
];

export const FILE_EXTENSION = [
  'jpg',
  'pdf',
  'jpeg',
  'gif',
  'png',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'htm',
  'html',
  'zip',
  'rar',
  'txt',
  'ds2',
  'rtf',
  'tif',
  'tiff',
  'dss',
  'wav',
  'mp3',
  'mp4',
  'xml',
  'bmp',
  'm4a',
];

export const UPLOAD_FILE_RULE = [
  {
    reportType: [9],
    rule: {
      maxSize: '50mb',
      fileExtension: ['pdf'],
      mutiple: false,
    },
  },
  {
    reportType: [1],
    rule: {
      maxSize: '50mb',
      fileExtension: FILE_EXTENSION,
      mutiple: true,
    },
  },
  {
    reportType: [2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 18, 19, 20],
    rule: {
      maxSize: '50mb',
      fileExtension: FILE_EXTENSION,
      mutiple: true,
    },
  },
];

export const ASSESSMENT_INFO = {
  ActionCompleted: false,
  ActionNotes: null,
  ActionRequired: false,
  ActionRequiredDueDate: null,
  ActionRequiredType: 0,
  ActionRequiredUserName: null,
  ActionSubject: null,
  AdminExtraFeeAmount: 0,
  AdminExtraFeeTaxPercentage: 0,
  AllowDoctorToViewPaperwork: false,
  AppointmentComment: null,
  AppointmentConfirmedDate: null,
  Appointments: [],
  AssessmentAttachment: [],
  AssessmentMethod: false,
  AssessmentMethodType: 'MAGVideo',
  AssessmentNumber: null,
  AssessmentServiceItems: [],
  Attendance: 0,
  AttendanceComment: null,
  AttendedDate: null,
  AuthorisedPurchaseAmount: null,
  AutoRemindReportCompletionDeadlineToDoctor: false,
  AutoRemindReportDraftCompletionDeadlineToMagStaff: false,
  AutoSendVideoLink: false,
  BilledDate: null,
  BodyParts: [],
  BookingSolicitor: null,
  BookingSolicitorId: null,
  CReference: null,
  CReferenceId: null,
  CancelledDate: null,
  CaseManager: null,
  CaseManagerId: null,
  ClaimNo: null,
  ClaimReqBookingComment: null,
  ClaimReqDateFrom: null,
  ClaimReqDateTo: null,
  ClaimReqLocation: null,
  ClaimReqSpecialty: null,
  ClaimType: null,
  ClaimantStatus: false,
  ClientRequestNo: null,
  Clinic: null,
  ClinicId: 0,
  ClinicOption: null,
  ClinicRoomId: 0,
  Comments: null,
  CommissionAmount: null,
  CommissionAmountGstNilEnabled: false,
  CommissionOnTopAmount: 0,
  CommissionOnTopRate: 0,
  CommissionRate: null,
  CommissionRateType: 0,
  CompletedDate: null,
  ConsentFormReceived: false,
  ConsentFormReceivedDate: null,
  Customer: null,
  CustomerId: null,
  DateFrom: null,
  DateTo: null,
  DatereadyCreateInvoice: null,
  Description: null,
  DictationComment: null,
  DictationOnedriveLinkFile: null,
  DictationOption: 0,
  DictationReceived: false,
  DictationReceivedDate: null,
  DictationSentToTypist: false,
  DictationTypistID: null,
  Doctor: null,
  DoctorAutoSendVideoLink: false,
  DoctorEassessUrl: null,
  DoctorId: null,
  DoctorInvoiced: false,
  DoctorInvoicedDate: null,
  EassessClaimantAddress: null,
  EassessClaimantEmail: null,
  EassessClaimantLocationChecklistReceived: false,
  EassessClaimantLocationChecklistReceivedDate: null,
  EassessClaimantLocationConfirmed: false,
  EassessClaimantLocationConfirmedDate: null,
  EassessClaimantLocationType: '0',
  EassessClaimantPhone: null,
  EassessDoctorAddress: null,
  EassessDoctorEmail: null,
  EassessDoctorLocationChecklistReceived: false,
  EassessDoctorLocationChecklistReceivedDate: null,
  EassessDoctorLocationConfirmed: false,
  EassessDoctorLocationConfirmedDate: null,
  EassessDoctorLocationType: '0',
  EassessDoctorPhone: null,
  EassessUrl: null,
  EmailInvoiceToMAG: false,
  EmailInvoiceToMAGDateSent: null,
  EmailInvoiceToMAGStaffSent: null,
  EmailPaymentReceiptToDoctor: false,
  EmailPaymentReceiptToDoctorDateSent: null,
  EmailReportDraftToDoctor: false,
  EmailReportDraftToDoctorBE: false,
  EmailReportDraftToDoctorByUser: '',
  EmailReportDraftToDoctorDateSent: null,
  EmailReportDraftToDoctorPE: false,
  EmailToCMConfirmAppointmentByUser: '',
  EmailToCMSolicitorViewReportRecent: null,
  EmailToCMSolicitorViewReportRecentByUser: null,
  EmailToCMsViewReportRecent: null,
  EmailToCMsViewReportRecentByUser: '',
  EmailToDoctorConfirmAppointmentByUser: '',
  EmailToPaperworkReceivedRecent: null,
  EmailToPaperworkReceivedRecentByUser: '',
  EmployerOfClaimant: null,
  ExcludeCM: false,
  ExcludeCMEmail: false,
  ExcludeDoctor: false,
  ExcludeDoctorEmail: false,
  ExcludePatient: false,
  ExcludePatientEmail: false,
  F_RDCCaseManagerId: null,
  F_RDCEmail: null,
  F_RDCSameBookingCM: false,
  F_RDCfirstName: null,
  F_RDClastName: null,
  FeedbackImproveService: null,
  HasInterpretationService: false,
  HasInterpreter: null,
  HasOtherFee: false,
  HasSendClaimantEassessLink: false,
  HasSendDoctorEassessLink: false,
  HomeVisitAddress: null,
  IMSApprovalCode: null,
  Id: 0,
  IlarsRef: null,
  IlarsWiroSolicitor: null,
  IlarsWiroSolicitorObj: null,
  IlarsWiroSolicitorOld: null,
  IncludeAdminExtraFeeToDoctorCommission: false,
  IncludeManualFee1ToDoctorCommission: false,
  IncludeManualFee2ToDoctorCommission: false,
  IncludeServiceItemFeeToDoctorCommission: false,
  InjuriedDate: null,
  InjuryDescription: null,
  InquiryDate: null,
  InquiryReceived: true,
  InsuranceClaimNo: null,
  InterpretationServiceClient: null,
  InterpretationServiceClientId: null,
  InterpretationServiceConfirmed: false,
  InterpretationServiceConfirmedDateTime: null,
  InterpretationStatus: 0,
  Interpreter: false,
  InterpreterAdditionalInformation: null,
  InterpreterConfirmedBy: '',
  InterpreterConfirmedDateTime: null,
  InterpreterEassessUrl: null,
  InterpreterEmail: null,
  InterpreterFirstName: null,
  InterpreterLanguage: null,
  InterpreterLastName: null,
  InterpreterMobile: null,
  InterpreterPhone: null,
  InterpreterStatusCancelledDate: null,
  InterpreterStatusReasonCancellation: null,
  InvoiceDescription: null,
  InvoiceId: 0,
  IsAdHoc: false,
  IsAllowCMSolicitorViewAmendedReport: false,
  IsAllowCMSolicitorViewReport: false,
  IsAllowCMViewAmendedReport: false,
  IsAllowCMViewReport: false,
  IsAppointmentConfirmed: false,
  IsBilled: false,
  IsInvoiceUrgentReport: false,
  IsLongPaperwork: false,
  IsPaymentRequested: false,
  IsPrepaymentPaid: false,
  IsRequiredForThisBooking: false,
  IsSendPrepaymentPaidToProvider: false,
  LCF: false,
  Language: null,
  MagAccountManagerId: null,
  MagBookingManagerId: null,
  MasterClient: null,
  MasterClientId: null,
  MedNegDoctorId: 0,
  MedNegId: null,
  MedNegNumber: '',
  NonAttendedDate: null,
  NotifyClaimantConfirmedAppointment: false,
  NotifyClaimantConfirmedAppointmentByUser: '',
  NotifyCmAboutAppointmentCancellation: false,
  NotifyCmAboutDidNotAttendCase: false,
  NotifyCmAppointmentConfirmed: false,
  NotifyCmAppointmentInquiry: false,
  NotifyCmSolicitorAboutDidNotAttendCase: false,
  NotifyCmSolicitorCancellation: false,
  NotifyDoctorAppointment: false,
  NotifyDoctorAppointmentConfirmed: false,
  NotifyDoctorAppointmentInquiry: false,
  OldBilled: false,
  OriginalMAGInfo: null,
  OriginalMAGInfo2: null,
  OriginalMAGInfoTxt: null,
  OriginalMAGInfoTxt2: null,
  OtherFee1Description: null,
  OtherFee1Label: null,
  OtherFee1TaxPercentage: 0,
  OtherFee1Value: 0,
  OtherFee2Description: null,
  OtherFee2Label: null,
  OtherFee2TaxPercentage: 0,
  OtherFee2Value: 0,
  OtherMethodSendingDate: null,
  PCaseManager: null,
  PCaseManagerId: null,
  PCustomer: null,
  PCustomerId: null,
  PaperWorkReceived: false,
  PaperworkComment: null,
  PaperworkExLink: '',
  PaperworkOtherExLink: '',
  PaperworkReceivedDate: null,
  Patient: null,
  PatientId: null,
  PaymentRequestedAttachment: null,
  PaymentRequestedDate: null,
  PaymentRequestedInvoiceAmount: null,
  PaymentRequestedInvoiceNo: null,
  PaymentRequestedInvoiceTax: null,
  PrepaymentPaidAttachment: null,
  PrepaymentPaidComment: null,
  PrepaymentPaidDate: null,
  PrepaymentRequired: false,
  PrepaymentRequiredDate: null,
  PurchaseOrderNo: null,
  ReadyCreateInvoice: false,
  ReasonCancellation: 0,
  ReportCompleted: false,
  ReportCompletedDate: null,
  ReportCompletedSentDate: null,
  ReportDraftComment: null,
  ReportDraftReceived: false,
  ReportDraftReceivedDate: null,
  ReportDraftSentDate: null,
  ReportReturnedFromDoctor: false,
  ReportSamplesAttachment: null,
  ReportTemplatesAttachment: null,
  ReportType: null,
  RequestExpectedCompletionDate: null,
  RoomName: '',
  SI_SameBookingCM: false,
  SI_SameClientAccEmail: false,
  S_RDCCaseManagerId: null,
  S_RDCEmail: null,
  S_RDCfirstName: null,
  S_RDClastName: null,
  SelectedDoctorProviderNoIdx: null,
  SelectedPaperworkToDoctorBies: [],
  SelectedSendInterpretation: false,
  SendDateEassessToClaimant: null,
  SendDateEassessToDoctor: null,
  SendDateEassessUrlToInterpreter: null,
  SendDateNotifyClaimantConfirmedAppointment: null,
  SendEassessToClaimantByUser: '',
  SendEassessToDoctorByUser: '',
  SendEassessUrlToClaimantLocation: false,
  SendEassessUrlToDoctorLocation: false,
  SendEassessUrlToInterpreter: false,
  SendEassessUrlToInterpreterByUser: null,
  SendInterpretationBy: '',
  SendInterpretationDateTime: null,
  SendInvoice: null,
  SendInvoice2: null,
  SendToWIRO: false,
  SentAmendedReportsByUser: '',
  SentAmendedReportsDate: null,
  SentByIsRequiredForThisBooking: null,
  SentByNotifyBookingCMSolicitorCancellation: null,
  SentByNotifyCmAboutDidNotAttendCase: null,
  SentByNotifyCmSolicitorAboutDidNotAttendCase: null,
  SentByNotifyDoctorAppointmentCancellation: null,
  SentDateEmailToCMConfirmAppointment: null,
  SentDateEmailToDoctorConfirmAppointment: null,
  SentDateIsRequiredForThisBooking: null,
  SentDateNotifyBookingCMAppointmentCancellation: null,
  SentDateNotifyBookingCMSolicitorCancellation: null,
  SentDateNotifyCMAppointmentInquiry: null,
  SentDateNotifyCmAboutDidNotAttendCase: null,
  SentDateNotifyCmSolicitorAboutDidNotAttendCase: null,
  SentDateNotifyDoctorAppointmentCancellation: null,
  SentDateNotifyDoctorAppointmentInquiry: null,
  SentDateToTypist: null,
  SentSolicitorAmendedReportsByUser: null,
  SentSolicitorAmendedReportsDate: null,
  SentToTypist: false,
  SentToTypistByUser: '',
  SessionAcceptsType: 0,
  SessionId: null,
  SpecialtyMedNegId: null,
  StaffId: null,
  Status: null,
  SubBodyParts: [],
  SubCaseManager1: null,
  SubCaseManager1Id: null,
  SubCaseManager2: null,
  SubCaseManager2Id: null,
  SubCaseManager3: null,
  SubCaseManager3Id: null,
  TaxTotal: 0,
  Total: 0,
  TotalAmountForCommissionCalculation: 0,
  TotalAmountForCommissionCalculationTax: 0,
  TotalWithoutTax: 0,
  Typist: null,
  TypistApproverdBy: null,
  TypistApproverdOn: null,
  TypistSubmittingDate: null,
  TypistTranscribingTime: null,
  UrgentReportCompleted: false,
  UrgentReportCompletedDate: null,
  UrgentReportStaffId: null,
  UserReadyCreateInvoice: null,
  WifroIlars: false,
  copy: false,
  isLocked: false,
  showHistoryAssessment: false,
};
